module.exports = __webpack_public_path__ + "assets/img/notFound.ea782e1c.svg";